export const intersects = <T>(array1: T[], array2: T[]): boolean => array1.some((item) => array2.includes(item));
